import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver } from '@angular/core';

import { ControlPropertySpecification } from '../../types/specification.types';
import { LayoutHostDirective } from '../layout-host.directive';
import { AbstractControl } from '../../types/control.types';
import { AbstractPropertyEditor } from '../../types/property-editor.types';
import { getOriginPropertyName, ControlModelPropertyEnum } from '../../types';
import { PropertyHandlerFactoryService } from '../../property-handlers/property-handler-factory.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-property-group',
  templateUrl: './property-group.component.html',
  styleUrls: ['./property-group.component.css']
})
export class PropertyGroupComponent implements OnInit {
  @Input() groupName: string;
  @Input() disableEditEntityProperty: boolean;

  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }

  set control(value: AbstractControl<any>) {
    this._control = value;
    this.loadComponents(this.propertySpecifications);
  }

  @Input()
  get propertySpecifications(): Array<ControlPropertySpecification> {
    return this._propertySpecifications;
  }

  set propertySpecifications(value: Array<ControlPropertySpecification>) {
    this._propertySpecifications = value;
    this.loadComponents(value);
  }

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;

  private _control: AbstractControl<any>;
  private _propertySpecifications: Array<ControlPropertySpecification>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private propertyHandlerFactoryService: PropertyHandlerFactoryService
  ) {}

  ngOnInit() {}

  private loadComponents(specifications: Array<ControlPropertySpecification>) {
    this.layoutHost.viewContainerRef.clear();
    if (!specifications) {
      return;
    }
    // åç±»æåº, orderä¸ºç©ºæèä¸º0 æç§æ·»å é¡ºåºï¼å©ä¸çæç§orderååº

    const noOrderSpecifications = specifications.filter((s) => !s.order);

    const orderSpecifications = specifications
      .filter((s) => s.order)
      .sort((a, b) => {
        return a.order - b.order;
      });

    const renderSpecifications = [...noOrderSpecifications, ...orderSpecifications];

    for (const specification of renderSpecifications) {
      this.loadComponent(specification);
    }
  }

  private loadComponent(specification: ControlPropertySpecification) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(specification.editorComponent);
    const componentRef = this.layoutHost.viewContainerRef.createComponent(componentFactory);
    const instance = <AbstractPropertyEditor>componentRef.instance;

    const propertyName = specification.propertyName;

    instance.control = this.control;
    instance.valueChange.subscribe((value: any) => {
      const handler = this.propertyHandlerFactoryService.getPropertyHandler(propertyName);
      if (handler) {
        handler.handleData(value, instance).subscribe(
          (s) => {
            this.setControlPropertyValue(specification, s);
          },
          (error) => {
            // TODO å¦æä¸å è¿ä¸ªï¼æ¢å¤å°åæ¥å¼ä¸çæ~~ï¼æªæ¥å¦æææ´å¥½åæ³åæ¥ä¿®æ¹
            setTimeout(() => {
              instance.value = this.control.model[propertyName];
            });
          }
        );
      } else {
        this.setControlPropertyValue(specification, value);
      }
    });
    instance.originValueChange.subscribe((value: any) => {
      this.control.model[getOriginPropertyName(propertyName)] = value;
    });

    if (this.disableEditEntityProperty) {
      const isDisabled =
        ControlModelPropertyEnum.AssociatedEntities === propertyName ||
        propertyName.startsWith(ControlModelPropertyEnum.EntityAttribute) ||
        ControlModelPropertyEnum.AssociatedEntityAttributes === propertyName ||
        ControlModelPropertyEnum.SelectCondition === propertyName ||
        ControlModelPropertyEnum.ShowCondition === propertyName;
      instance.disabled = isDisabled;
    }

    instance.settings = specification.editorSettings;
    instance.caption = specification.caption;
    instance.propertyName = propertyName;
    instance.initializeControlValue(this.control.model[propertyName]);
  }

  /**
   * è®¾ç½®æ§ä»¶å±æ§å¼
   *
   */
  private setControlPropertyValue(specification: ControlPropertySpecification, value: any) {
    this.control.model[specification.propertyName] = value;
    this.control.propertyValueChanged(specification.propertyName, value);
  }
}
